/**
 * Analytics utility for tracking user interactions
 * Supports Vercel Analytics and Microsoft Clarity
 */

// Track custom events for Vercel Analytics
export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  // Vercel Analytics tracking
  if (typeof window !== "undefined" && (window as any).va) {
    (window as any).va("track", eventName, properties);
  }

  // Microsoft Clarity tracking
  if (typeof window !== "undefined" && (window as any).clarity) {
    (window as any).clarity("event", eventName);
  }

  // Console log for development
  if (process.env.NODE_ENV === "development") {
    console.log("Analytics Event:", eventName, properties);
  }
};

// Track resume downloads
export const trackResumeDownload = () => {
  trackEvent("resume_download", {
    timestamp: new Date().toISOString(),
  });
};

// Track project interactions
export const trackProjectClick = (
  projectName: string,
  action: "view_live" | "view_code"
) => {
  trackEvent("project_click", {
    project_name: projectName,
    action,
    timestamp: new Date().toISOString(),
  });
};

// Track contact form submissions
export const trackFormSubmission = (status: "success" | "error") => {
  trackEvent("contact_form_submission", {
    status,
    timestamp: new Date().toISOString(),
  });
};

// Track social link clicks
export const trackSocialClick = (platform: string) => {
  trackEvent("social_link_click", {
    platform,
    timestamp: new Date().toISOString(),
  });
};

// Track section views
export const trackSectionView = (sectionName: string) => {
  trackEvent("section_view", {
    section: sectionName,
    timestamp: new Date().toISOString(),
  });
};
